import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-4 banner banner-light" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "science", -1)
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "flex space-x-4" }
const _hoisted_5 = ["onKeydown", "onClick"]
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex mt-4" }
const _hoisted_9 = { class: "mx-auto select-none" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = { class: "flex flex-col w-full mt-10 space-y-6" }
const _hoisted_12 = { class: "relative flex self-start w-full space-x-4" }
const _hoisted_13 = { class: "text-lg" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  style: {"margin-top":"-2px","font-size":"18px","vertical-align":"middle"},
  class: "mr-1 material-icons text-primary"
}, " auto_awesome ", -1)
const _hoisted_17 = { class: "mb-2 text-muted" }
const _hoisted_18 = { class: "grid grid-cols-2 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_ArticleHandle = _resolveComponent("ArticleHandle")!
  const _component_Chipset = _resolveComponent("Chipset")!
  const _component_MinimalExercisePreview = _resolveComponent("MinimalExercisePreview")!
  const _directive_wave = _resolveDirective("wave")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("misc.experimental_feature_warning")), 1)
      ])
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("exercise_import.select_format")), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataFormatsAsSelectableOptions, (format) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            tabindex: "0",
            onKeydown: _withKeys(($event: any) => (_ctx.onSelect(format.value)), ["enter"]),
            onClick: ($event: any) => (_ctx.onSelect(format.value)),
            class: _normalizeClass([{
						'outline-success  hover:bg-opacity-20 outline-4 border-transparent bg-success-light bg-opacity-10':
							_ctx.selectedFormat === format.value,
						'hover:bg-light': _ctx.selectedFormat !== format.value,
					}, "transition-colors duration-100 cursor-pointer card card-border"]),
            key: 'format-' + format.value
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                class: "mx-auto pointer-events-none select-none w-18",
                src: format.description
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(format.content), 1)
            ])
          ], 42, _hoisted_5)), [
            [_directive_wave]
          ])
        }), 128))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["mt-8 mb-2", { invisible: _ctx.selectedFormat === null }])
      }, [
        _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("exercise_import.choose_file")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("input", {
            type: "file",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileInputChange && _ctx.onFileInputChange(...args)))
          }, null, 32)
        ])
      ], 2)
    ], 512), [
      [_vShow, _ctx.currentStep === 'initial']
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.exercises.length), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("exercise_import.detected_exercises")), 1)
          ]),
          (_ctx.exercises.length > 0)
            ? (_openBlock(), _createBlock(_component_Dropdown, {
                key: 0,
                class: "self-start w-1/4 mb-auto -mt-3",
                id: "imported-exercises-state-dropdown",
                options: _ctx.exerciseStateOptions,
                modelValue: _ctx.importedExercisesStateProxy,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.importedExercisesStateProxy) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("exercise_import.imported_exercises_state")), 1)
                ]),
                _: 1
              }, 8, ["options", "modelValue"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.extras.tags?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("h4", _hoisted_15, [
                _hoisted_16,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("exercise_import.extras_detected_tags")), 1)
              ]),
              _createElementVNode("p", _hoisted_17, [
                _createTextVNode(_toDisplayString(_ctx.$t("exercise_import.extras_detected_tags_description")) + " ", 1),
                _createVNode(_component_ArticleHandle, { articleId: 'what_are_tags_for' }),
                _createTextVNode(". ")
              ]),
              (_ctx.exercises.length > 0)
                ? (_openBlock(), _createBlock(_component_Chipset, {
                    key: 0,
                    class: "-ml-2",
                    options: _ctx.tagsAsOptions,
                    modelValue: _ctx.selectedTagsProxy,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTagsProxy) = $event))
                  }, null, 8, ["options", "modelValue"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exercises, (exercise, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'imported-exercise-' + index,
              class: ""
            }, [
              _createVNode(_component_MinimalExercisePreview, {
                selectable: false,
                exercise: exercise
              }, null, 8, ["exercise"])
            ]))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, _ctx.currentStep === 'file_chosen']
    ])
  ]))
}